const messages = {
    scanWithBankApp: "သင့်ဘဏ်အက်ပ်ဖြင့် စကင်ဖတ်ပါ",
    scanWithCreditCardApp: "သင့်ခရက်ဒစ်ကတ်အက်ပ်ဖြင့် စကင်ဖတ်ပါ",
    scanOrOpenApp: "ငွေပေးချေမှုပြီးမြောက်ရန် စကင်ဖတ်ပါ သို့မဟုတ် အက်ပ်ကိုဖွင့်ပါ",
    scanForPayment: "ငွေပေးချေရန် စကင်ဖတ်ပါ",
    scanWithBankApp: 'ငွေပေးချေရန် သင့်ဘဏ်အက်ပ်ဖြင့် စကင်ဖတ်ပါ',
    changePaymentWarning: "ငွေပေးချေမှုနည်းလမ်းပြောင်းလိုက်သည်နှင့် ယခင် QR Code သည် အသုံးပြု၍မရတော့ပါ။ ကျေးဇူးပြု၍ နည်းလမ်းအသစ်ကိုသာ အသုံးပြုပါ။",
    swapShop: "ဆိုင်အသစ်သို့<br>ပြောင်းလိုပါသလား။",
    swapShopDespt: "ယခင်ဆိုင်မှ ရွေးချယ်ထားသော ပစ္စည်းများကို သိမ်းဆည်းထားမည်ဖြစ်ပြီး နောက်မှ မှာယူနိုင်ပါသည်",
    sorryForInconvenient: 'အဆင်မပြေမှုအတွက် တောင်းပန်ပါသည်',
    openAt: 'ဖွင့်ချိန်',
    shopIsClosedToday: 'ယနေ့ ဆိုင်ပိတ်ပါသည်',
    checkOrderedItem: 'မှာယူထားသော အစားအစာများကို စစ်ဆေးပါ',
    tryAgainIn: 'ထပ်စမ်းပါ',
    lockUserPIN: "PIN ကို ၅ ကြိမ်ထက်ပိုမှားယွင်းစွာ ထည့်သွင်းပါပြီ",
    lockUserPINDespt: "၅ မိနစ်အကြာ ထပ်စမ်းပါ",
    inValidPIN: 'PIN မှားယွင်းပါသည်',
    enterPasswordToAccessMenu: "မီနူးသို့ ဝင်ရောက်ရန် PIN ထည့်ပါ",
    customersCanGetPasswordFromStaff: "ဖောက်သည်များသည် ဝန်ထမ်းထံမှ PIN ကို ရယူနိုင်ပါသည်",
    tableNotAvailable: "စားပွဲ မရနိုင်ပါ",
    contactStaffToOpenTable: "စားပွဲဖွင့်ရန် ဝန်ထမ်းကို ဆက်သွယ်ပါ",
    outOfRestaurantRange: "စားသောက်ဆိုင်၏ နယ်ပယ်အတွင်း မဟုတ်ပါ",
    phoneIsMoreThan100MetersAwayFromRestaurant: "သင့်ဖုန်းသည် စားသောက်ဆိုင်မှ မီတာ ၁၀၀ ကျော် ဝေးကွာနေပါသည်",
    restaurantIsCurrentlyClosed: "စားသောက်ဆိုင် ယခု ပိတ်ထားပါသည်",
    restaurantOpenHours: "မီးဖိုချောင် ဖွင့်ချိန်",
    packingSize: 'ထုပ်ပိုးအရွယ်အစား',
    shippingDelivery: 'ပို့ဆောင်ရေး',
    waitForPaymentDelivery: 'ငွေပေးချေမှု စောင့်ဆိုင်းနေသည်',
    readyForPcikup: 'ထုတ်ယူရန် အဆင်သင့်',
    noNotifyNow: "ယခု အကြောင်းကြားစာ မရှိပါ",
    noNotifyNowDespt: "ဝန်ဆောင်မှုကို စတင်အသုံးပြုသည်နှင့် အကြောင်းကြားစာများ ဤနေရာတွင် ပေါ်လာပါမည်",
    newAddressDespt: "ပို့ဆောင်ရေး ပိုမိုလွယ်ကူစေရန် မှန်ကန်သော တည်နေရာကို pin ထိုးပေးပြီး တည်နေရာ ခွင့်ပြုချက်ပေးပါ",
    deleteAddressSuccess: 'လိပ်စာ ဖျက်ပြီးပါပြီ',
    createProfileSuccess: "ပရိုဖိုင် ဖန်တီးပြီးပါပြီ",
    ex: 'ဥပမာ',
    receiverName: 'လက်ခံသူအမည်',
    editAddress: 'လိပ်စာ ပြင်ဆင်ရန်',
    nameInputInvalid: 'အမည် မှားယွင်းပါသည်',
    openInGoogleMap: 'Google Map တွင် ဖွင့်ပါ',
    pleaseSelectPaymentMethod: 'ကျေးဇူးပြု၍ ငွေပေးချေမှုနည်းလမ်း ရွေးချယ်ပါ',
    noDeliveryAddress: 'ပို့ဆောင်ရေးလိပ်စာ မတွေ့ပါ',
    noDeliveryAddressDespt: 'ကျေးဇူးပြု၍ ပို့ဆောင်ရေးလိပ်စာ ထည့်သွင်းပါ',
    deliveryType: 'ပို့ဆောင်ရေး',
    pickupType: 'ထုတ်ယူရန်',
    shopIsClose: 'ဆိုင်ပိတ်ပါသည်',
    openingHoursDespt: 'ဖွင့်ချိန်',
    contactShop: 'ဆိုင်ကို ဆက်သွယ်ပါ',
    pickupAtShop: 'ထုတ်ယူရန်',
    thanksForOrderingDespt: 'ကျေးဇူးတင်ပါသည်။<br>ထပ်မံတွေ့ဆုံရန် မျှော်လင့်ပါသည်!',
    deliveredSuccess: 'ပို့ဆောင်ပြီးပါပြီ',
    expireIn: 'သက်တမ်းကုန်ရန်',
    waitForPayment: 'ငွေပေးချေမှု စောင့်ဆိုင်းနေသည်',
    waitForPaymentDespt: "ကျေးဇူးပြု၍ စနစ်မှ ငွေပေးချေမှု အတည်ပြုချက်ကို စောင့်ပါ။<br>ငွေမပေးချေရသေးပါက သတ်မှတ်ချိန်အတွင်း ငွေပေးချေပါ၊ မဟုတ်ပါက အော်ဒါ ပယ်ဖျက်ခံရနိုင်ပါသည်။",
    newOrderIn: 'အသစ်',
    inputRequestDetails: 'တောင်းဆိုမှု အသေးစိတ် ထည့်သွင်းပါ',
    notification: 'အကြောင်းကြားစာ',
    noticeIfOrderReady: 'သင့်အော်ဒါ ထုတ်ယူရန် အဆင်သင့်ဖြစ်သည့်အခါ အကြောင်းကြားပါမည်',
    orderIsReady: 'သင့်အော်ဒါ ထုတ်ယူရန် အဆင်သင့်ဖြစ်ပါပြီ',
    thanksForOrdering: 'ဝန်ဆောင်မှုကို အသုံးပြုသည့်အတွက် ကျေးဇူးတင်ပါသည်',
    toPay: 'ငွေပေးချေရန်',
    letOrder: 'မီနူးစာမျက်နှာသို့ သွား၍ ယခု စတင်မှာယူပါ',
    noTransaction: 'လုပ်ဆောင်မှု မရှိပါ',
    menulists: 'မီနူးစာရင်း',
    editPersonalDetails: 'အချက်အလက် ပြင်ဆင်ရန်',
    trackOrder: 'အော်ဒါ ခြေရာခံခြင်း',
    myAccount: 'ကျွန်ုပ်၏ အကောင့်',
    cart: 'ဈေးခြင်း',
    helpCenter: 'အကူအညီစင်တာ',
    allPurchaseHistory: 'ဝယ်ယူမှုမှတ်တမ်း',
    purchaseHistory: 'ဝယ်ယူမှုမှတ်တမ်း',
    personalInfo: 'ကိုယ်ရေးအချက်အလက်',
    cutlery: 'ဇွန်း/ခက်ရင်း',
    km: 'ကီလိုမီတာ',
    totalAmountSum: 'စုစုပေါင်း',
    selectedItemList: 'ရွေးချယ်ထားသော ပစ္စည်းများ',
    iAm: 'ကျွန်ုပ်သည်',
    orderedBy: 'မှာယူသူ',
    shareQRtoFriend: 'QR Code မျှဝေပါ',
    share: 'မျှဝေပါ',
    hasItemInBasket: 'ခြင်းထဲတွင် ပစ္စည်းများ ရှိနေပါသည်',
    hasItemInBasketDespt: 'မီးဖိုချောင်သို့ ပို့ရန် မမေ့ပါနှင့်',
    updatedAtQR: 'နောက်ဆုံး အပ်ဒိတ်',
    orderSent: 'မီးဖိုချောင်သို့ အော်ဒါပို့ပြီးပါပြီ',
    orderSentDespt: 'စားသောက်ဆိုင်က သင့်အစားအစာ ပြင်ဆင်နေပါသည်',
    checkGramdTotalIn: 'စုစုပေါင်းပမာဏကို စစ်ဆေးနိုင်ပါသည်',
    vatNotInclude: 'ဤစျေးနှုန်းတွင် အခွန်၊ ဝန်ဆောင်ခနှင့် လျှော့စျေး မပါဝင်ပါ',
    accept: 'လက်ခံသည်',
    termOfService: 'ဝန်ဆောင်မှုစည်းမျဉ်း',
    onPending: 'စောင့်ဆိုင်းနေသည်',
    OnSuccessOrder: 'အောင်မြင်',
    prepareingOrder: 'ပြင်ဆင်နေသည်',
    deliveringOrder: 'ပို့ဆောင်နေသည်',
    pickupOrderReady: 'ထုတ်ယူရန် အဆင်သင့်',
    pickedupOrder: 'ထုတ်ယူပြီးပါပြီ',
    deliveredOrder: 'ပို့ဆောင်ပြီးပါပြီ',
    shopReceivedOrder: 'ဆိုင်က အော်ဒါလက်ခံပြီး',
    orderId: 'အော်ဒါ ID',
    orderDetails: 'အော်ဒါ အသေးစိတ်',
    deliveryFee: 'ပို့ဆောင်ခ',
    searchDriver: 'ယာဉ်မောင်း ရှာဖွေနေသည်',
    driverFrom: 'ယာဉ်မောင်း',
    change: 'ပြောင်းရန်',
    deliveryAddress: 'ပို့ဆောင်ရေးလိပ်စာ',
    location: 'တည်နေရာ',
    addressName: 'လိပ်စာအမည်',
    addressNameDespt: 'ဥပမာ- ကွန်ဒိုအမည်၊ ရွာအမည်',
    addressDescription: 'လိပ်စာ အသေးစိတ်',
    addressDescriptionDespt: 'ဥပမာ- အဆောက်အအုံနံပါတ်၊ လမ်းကြား',
    noteToDriver: 'ယာဉ်မောင်းထံ မှတ်ချက်',
    noteToDriverDespt: 'ဥပမာ- ဝင်ပေါက်ရှိ စားပွဲပေါ်တွင် ထားပါ',
    inputAddressForm: 'ပို့ဆောင်ရေးလိပ်စာ ထည့်သွင်းပါ',
    plsPinAddress: 'သင့်တည်နေရာကို pin ထိုးပါ',
    pinLocation: 'ပို့ဆောင်မည့်နေရာ pin ထိုးပါ',
    createNewAddress: 'လိပ်စာအသစ် ဖန်တီးပါ',
    savedAddress: 'သိမ်းဆည်းထားသော လိပ်စာ',
    phoneNumber: 'ဖုန်းနံပါတ်',
    noRequired: 'မဖြည့်လည်းရ',
    resendCode: 'ကုဒ် ပြန်ပို့ပါ',
    didNotGetCode: 'ကုဒ် မရရှိပါသလား။',
    resendIn: 'ပြန်ပို့ရန်',
    next: 'ရှေ့ဆက်',
    createAccount: 'အကောင့် ဖန်တီးပါ',
    createAccountDespt: 'ဆက်လက်လုပ်ဆောင်ရန် အောက်ပါဖောင်ကို ဖြည့်ပါ',
    sendCodeViaSMS: 'SMS ဖြင့် ကုဒ်ပို့ပါ',
    inputOTP: 'OTP ထည့်ပါ',
    inputOTPDespt: 'ကျေးဇူးပြု၍ ပို့ထားသော ဂဏန်း ၆ လုံး ကုဒ်ကို ထည့်ပါ',
    termAndPolicy: 'စည်းမျဉ်းနှင့် မူဝါဒ',
    termAndPolicy1: 'ဝန်ဆောင်မှုကို အသုံးပြုခြင်းဖြင့် သင်သည် သဘောတူပါသည်',
    termAndPolicy2: 'စည်းမျဉ်းနှင့် မူဝါဒ အပြည့်အစုံကို ဖတ်ရန် နှိပ်ပါ',

    loginWithPhoneNumber: 'ဖုန်းနံပါတ်ဖြင့် ဝင်ရောက်ပါ',
    loginWithPhoneNumberDespt: 'အထောက်အထားစစ်ဆေးရန် OTP လက်ခံရရှိရန် သင့်ဖုန်းနံပါတ် ထည့်ပါ',
    backToOrder: 'မီနူးသို့ ပြန်သွားပါ',
    PaymentMethod: 'ငွေပေးချေမှု',
    paymentAmount: 'ငွေပေးချေမှုပမာဏ',
    paymentConfirmation: 'ငွေပေးချေမှု အတည်ပြုခြင်း',
    cancelPayment: 'ငွေပေးချေမှု ပယ်ဖျက်ရန်',
    paidSuccess: 'ငွေပေးချေပြီးပါပြီ',
    haveNotPurchased: 'မဝယ်ယူရသေးပါ',
    haveNotPurchased2: 'ငွေပေးချေမှု မအောင်မြင်ပါက ဝန်ထမ်းကို ဆက်သွယ်ပါ',
    canNotOrderItem: 'ငွေပေးချေနေစဉ် အစားအစာ မှာယူ၍မရပါ',
    checkPaymentStatus: 'အခြေအနေ စစ်ဆေးပါ',
    pendingPayment: 'ငွေပေးချေမှု စောင့်ဆိုင်းနေသည်',
    askForReceipt: 'ပြေစာလိုအပ်ပါက ဝန်ထမ်းကို ဆက်သွယ်ပါ',
    paymentSuccess: 'ငွေပေးချေမှု အောင်မြင်',
    summaryPayment: 'အကျဉ်းချုပ်',
    numberOfGuest: 'ဧည့်သည် အရေအတွက်',
    closeTab: 'ပိတ်ရန်',
    addCredit: 'ခရက်ဒစ်ကတ် ထည့်ပါ',
    QRPayment: 'QR ငွေပေးချေမှု',
    cardPayment: 'ခရက်ဒစ်ကတ်',
    payWithStaff: 'ကောင်တာတွင် ပေးချေပါ',
    selectPaymentMethod: 'ငွေပေးချေမှုနည်းလမ်း ရွေးချယ်ပါ',
    checkOut: 'ငွေရှင်းရန်',
    startOrderBeforeCallStaff: 'ဝန်ထမ်းကို ခေါ်မတိုင်မီ အစားအစာ မှာယူပါ',
    basket: 'ခြင်း',
    spoon: 'ဇွန်း/ခက်ရင်း တောင်းဆိုရန်',
    knife: 'ဓား တောင်းဆိုရန်',
    chopstick: 'တူ တောင်းဆိုရန်',
    cup: 'ခွက် တောင်းဆိုရန်',
    plate: 'ပန်းကန် တောင်းဆိုရန်',
    glass: 'ဖန်ခွက် တောင်းဆိုရန်',
    payBill: 'ငွေတောင်းခံရန်',
    viewAll: 'အားလုံးကြည့်ရန်',
    recommendMenu: 'အကြံပြုချက်',
    OnSuccess: 'အောင်မြင်',
    OnPreparing: 'ပြင်ဆင်နေသည်',
    messageSent: 'ကျေးဇူးပြု၍ ဝန်ထမ်းကို စောင့်ပါ',
    outOfStock: 'ကုန်ဆုံးပါပြီ',
    QRCode: 'QR Code',
    GenerateQRCode: 'QR Code ဖန်တီးပါ',
    ForQROrder: 'အစားအစာ မှာယူခြင်းနှင့် ဆိုင်တွင်း ဝန်ဆောင်မှု တောင်းဆိုခြင်းအတွက်',
    QROrderDescription: 'ဖောက်သည်များ စကင်ဖတ်၍ အစားအစာ မှာယူနိုင်ရန်နှင့် ဆိုင်တွင်း ဝန်ဆောင်မှု တောင်းဆိုနိုင်ရန် QR Code ဖန်တီးနိုင်ပါသည်',
    SelectTable: 'စားပွဲ ရွေးချယ်ပြီး ဧည့်သည်အရေအတွက် ထည့်ပါ။',
    shopname: 'ဆိုင်အမည်',
    numberOfCustomer: 'ဖောက်သည် အရေအတွက် (ဦးရေ)',
    numberOfCustomerDescription: 'ဖောက်သည် အရေအတွက် ထည့်ပါ၊ အနည်းဆုံး ၁ ဦး',
    currentUser: 'အသုံးပြုသူ',
    guest: 'ဧည့်သည်',
    orderItem: 'အော်ဒါ အကျဉ်းချုပ်',
    orderItemNav: 'အော်ဒါ အကျဉ်းချုပ်',
    callStaff: 'ဝန်ထမ်း ခေါ်ရန်',
    callStaffDialog: 'ဘာအကူအညီ လိုအပ်ပါသလဲ။',
    cutlery: 'ဇွန်း/ခက်ရင်း တောင်းဆိုရန်',
    seasoning: 'အရသာမှုန့် တောင်းဆိုရန်',
    refillDrink: 'အချိုရည် ဖြည့်ပေးရန်',
    other: 'အခြား',
    tableNumber: 'စားပွဲ',
    menuList: 'မီနူး',
    selectedItem: 'အစားအစာ မှာယူရန်',
    selectedItemNav: 'အစားအစာ မှာယူရန်',
    checkOrderBeforeConfirm: 'ကျေးဇူးပြု၍ စားသောက်ဆိုင်သို့ ပို့မတိုင်မီ အော်ဒါအသေးစိတ်နှင့် စုစုပေါင်းကို စစ်ဆေးပါ',
    checkOrderBeforeConfirm2: '',
    startOrder: 'မှာယူရန် စတင်ပါ',
    foodCategory: 'အမျိုးအစား',
    searchByName: 'ကုန်ပစ္စည်းအမည်ဖြင့် ရှာပါ...',
    noPreduct: 'ကုန်ပစ္စည်း မရှိပါ',
    noSelectedProduct: 'ရွေးချယ်ထားသော ပစ္စည်း မရှိပါ',
    noSelectedProductDespt: 'ကုန်ပစ္စည်းများ ရွေးချယ်ပါက ဤစာမျက်နှာတွင် ပြသပါမည်',
    backToMenu: 'မီနူးသို့ သွားပါ',
    removeSelected: 'ဤပစ္စည်းကို ဖယ်ရှားလိုပါသလား။',
    confirmOrder: 'အော်ဒါ ပို့ရန်',
    endOfTransection: 'ဝန်ဆောင်မှု ပြီးဆုံးပါပြီ',
    endOfTransectionDialog: 'အသုံးပြုရာတွင် ပြဿနာ ရှိပါက ဝန်ထမ်းကို ဆက်သွယ်ပါ',
    note: 'မှတ်ချက်',
    orderTime: 'မှာယူချိန်',
    orderMoreFood: 'ပင်မမီနူးသို့ ပြန်သွားပါ',
    orderPreparing: 'စားဖိုမှူးများက သင့်အစားအစာ ပြင်ဆင်နေပါသည်။ ခဏစောင့်ပါ။ မကြာမီ ဧည့်ခံပါမည်',
    orderPreparing2: '',
    sendingOrder: 'သင့်အော်ဒါကို မီးဖိုချောင်သို့ ပို့နေပါသည်...',
    login: 'ဝင်ရောက်ပါ',
    forgetPassword: 'စကားဝှက် မေ့သွားပါသလား',
    loginWithGmail: 'Gmail ဖြင့် ဝင်ရောက်ပါ',
    or: 'သို့မဟုတ်',
    loginAsStaff: 'ဝန်ထမ်းအဖြစ် ဝင်ရောက်ပါ',
    billOrder: 'ဘီလ်အော်ဒါ',
    table: 'စားပွဲ',
    billOrderDialog: 'မီနူးကြည့်ရန်နှင့် မှာယူရန် QR Code စကင်ဖတ်ပါ',
    billOrderDialog2: 'အသုံးပြုရာတွင် ပြဿနာ ရှိပါက ဝန်ထမ်းကို ဆက်သွယ်ပါ',
    selectTableAleart: 'QR Code မဖန်တီးမီ စားပွဲ ရွေးပါ',
    emptyCartDialog: 'လုပ်ဆောင်မှု မရှိပါ',
    emptyCartDialogDespt: 'အော်ဒါ အတည်ပြုပါက မှာယူထားသော ပစ္စည်းစာရင်း ဤစာမျက်နှာတွင် ပြသပါမည်',
    served: 'ဧည့်ခံပြီး',
    contactOurStaff: 'ဝန်ထမ်းကို ဆက်သွယ်ပါ',
    contactOurStaff2: 'အကူအညီ လိုအပ်ပါက',
    addToCart: 'ခြင်းထဲ ထည့်ပါ',
    noteToShop: 'ဆိုင်သို့ မှတ်ချက်',
    addYourRequest: 'သင့်တောင်းဆိုချက် ထည့်ပါ',
    branchName: 'ဌာနခွဲအမည်',
    businessType: 'လုပ်ငန်းအမျိုးအစား',
    taxID: 'အခွန်ကိုယ်ပိုင်နံပါတ်',
    vat: 'အခွန်',
    exclusive: 'အခွန်မပါ',
    inclusive: 'အခွန်ပါ',
    serviceCharge: 'ဝန်ဆောင်ခ',
    address: 'လိပ်စာ',
    address1: 'လိပ်စာ လိုင်း ၁',
    address2: 'လိပ်စာ လိုင်း ၂',
    tel: 'ဖုန်း',
    businessType1: 'ယေဘုယျ',
    businessType2: 'စားသောက်ဆိုင်',
    businessType3: 'တည်းခိုခန်း',
    shopopen: 'ဖွင့် - ပိတ်',
    open: 'ဖွင့်',
    closed: 'ပိတ်',
    languagetxt: 'ဘာသာစကား',
    language: 'ဘာသာစကားနှင့် အချိန်ဇုန်',
    languageTH: 'ထိုင်း',
    languageEN: 'အင်္ဂလိပ်',
    setting: 'ဆက်တင်',
    shop: 'ဆိုင်',
    timezone: 'အချိန်ဇုန်',
    deliveryProviders: 'ပို့ဆောင်ရေး ဝန်ဆောင်မှုပေးသူများ',
    adddeliveryProviders: 'ဝန်ဆောင်မှုပေးသူ ထည့်ပါ',
    lastUpdate: 'နောက်ဆုံး အပ်ဒိတ်',
    logo: 'လိုဂို',
    updateData: 'ဒေတာ အပ်ဒိတ်လုပ်ပါ',
    submit: 'တင်သွင်းပါ',
    cancel: 'ပယ်ဖျက်ရန်',
    normal: 'ပုံမှန်',
    loading: 'ဖွင့်နေသည်...',
    editing: 'ပြင်ဆင်နေသည်',
    confirmUpdate: 'ဒေတာ အပ်ဒိတ်လုပ်လိုပါသလား။',
    selectedShoptype: 'လုပ်ငန်းအမျိုးအစား ရွေးပါ...',
    selectshop: 'ဌာနခွဲ ရွေးပါ',
    save: 'သိမ်းရန်',
    reporttxt: 'အစီရင်ခံစာ',
    general: 'ယေဘုယျ',
    signOut: 'ထွက်ရန်',
    registration: '',
    unit: 'ယူနစ်',
    category: 'အမျိုးအစား',
    product: 'ကုန်ပစ္စည်း',
    export: 'တင်ပို့ရန်',
    exportKBank: 'K-Bank တင်ပို့ရန်',
    date: 'ရက်စွဲ',
    to: 'မှ',
    status: 'အခြေအနေ',
    vatAmount: 'အခွန်',
    netTotalNonVAT: 'စုစုပေါင်း (အခွန်မပါ)',
    receiptNumber: 'ပြေစာနံပါတ်',
    grandTotal: 'စုစုပေါင်း',
    netAmountVATTotal: 'ခွဲစုစုပေါင်း',
    netTotalIncVAT: 'စုစုပေါင်း (အခွန်ပါ)',
    proofOfPayment: 'ငွေပေးချေမှု အထောက်အထား',
    paymentType: 'ငွေပေးချေမှု အမျိုးအစား',
    paymentType0: 'ငွေသား',
    paymentType1: 'ခရက်ဒစ်ကတ်',
    paymentType2: 'ကူပွန်',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: 'စရံ',
    paymentType7: 'ပို့ဆောင်ရေး',
    paymentType8: 'အွန်လိုင်း',
    paymentType9: 'Line Pay',
    paymentType10: 'စိတ်ကြိုက် ငွေပေးချေမှု',
    paymentType12: 'KBank',
    paid: 'ပေးချေပမာဏ',
    sentSuccessfully: 'ပို့ပြီးပါပြီ',
    pluCode: 'ဘားကုဒ်',
    netAmount: 'အသားတင် စုစုပေါင်း',
    discount: 'လျှော့စျေး',
    timeOfOrder: 'မှာယူချိန်',
    orderDate: 'မှာယူသည့်ရက်',
    preparing: 'ပြင်ဆင်နေသည်',
    paymentDetail: 'ငွေပေးချေမှု အသေးစိတ်',
    orderNumber: 'အော်ဒါနံပါတ်',
    delivered: 'သတ်မှတ်ရက်',
    deliveredDate: 'ပို့ဆောင်ချိန်',
    payment: 'ငွေပေးချေမှု',
    productName: 'ကုန်ပစ္စည်းအမည်',
    quantity: 'အရေအတွက်',
    priceUnit: ' စျေးနှုန်း / ယူနစ်',
    baht: 'ဘတ်',
    profit: 'အမြတ်',
    sales: 'ရောင်းအား',
    billAmount: 'ဘီလ် စုစုပေါင်း',
    total: 'စုစုပေါင်း',
    bill: 'ဘီလ်',
    discountAmount: 'လျှော့စျေးပမာဏ',
    averageBill: 'ပျမ်းမျှ / ဘီလ်',
    voidbillTotal: 'ပယ်ဖျက်ဘီလ် စုစုပေါင်း',
    salesByDaily: 'နေ့စဥ် ရောင်းအား',
    salesByMonth: 'လစဥ် ရောင်းအား',
    bestSellers: 'အရောင်းရဆုံး',
    bestSellerstype: 'အရောင်းရဆုံး အမျိုးအစား',
    salesBydate: 'ရက်စွဲအလိုက် ရောင်းအား',
    number: 'စဉ်',
    categoryName: 'အမျိုးအစားအမည်',
    newOrder: 'အော်ဒါ ပို့ရန်',
    reject: 'ငြင်းပယ်',
    inProgressTime: 'ဆောင်ရွက်နေချိန်',
    rejectTime: 'ငြင်းပယ်ချိန်',
    cancelTime: 'ပယ်ဖျက်ချိန်',
    cause: 'အကြောင်းရင်း',
    preparingToShip: 'ပြင်ဆင်နေသည်',
    totalAmount: 'စုစုပေါင်း',
    order: 'အော်ဒါ',
    deposit: 'စရံ',
    billSave: 'သိမ်းရန်',
    ReceivingOrder: 'စားပွဲဖွင့်/အော်ဒါလက်ခံ',
    orderNo: 'အော်ဒါ နံပါတ်',
    remark: 'မှတ်ချက်',
    receiptStatus: 'ပြေစာ အခြေအနေ',
    back: 'နောက်သို့',
    detail: 'အသေးစိတ်',
    countSales: 'အရေအတွက်',
    onhandQty: 'လက်ကျန်',
    stdCost: 'ကုန်ကျစရိတ်',
    employees: 'ဝန်ထမ်းများ',
    employeesname: 'ဝန်ထမ်းအမည်',
    salesTotal: 'ရောင်းအား စုစုပေါင်း',
    totalBill: 'ဘီလ် အားလုံးစုစုပေါင်း',
    billActive: 'ရောင်းချဘီလ် အရေအတွက်',
    billVoice: 'ပယ်ဖျက်ဘီလ် အရေအတွက်',
    billDeposit: 'စရံဘီလ် အရေအတွက်',
    discountItem: 'ပစ္စည်းလျှော့စျေး စုစုပေါင်း',
    billDiscountAmount: 'ဘီလ်လျှော့စျေး စုစုပေါင်း',
    billDiscount: 'လျှော့စျေးဘီလ် အရေအတွက်',
    payTotal: 'ငွေပေးချေမှု စုစုပေါင်း',
    deliveryProvider: 'ပို့ဆောင်ရေး ဝန်ဆောင်မှုပေးသူ',
    deliveryDetail: 'ပို့ဆောင်ရေး အသေးစိတ်',
    customDetail: 'စိတ်ကြိုက် ငွေပေးချေမှု အသေးစိတ်',
    customPaymentName: 'စိတ်ကြိုက် ငွေပေးချေမှုအမည်',
    firstInvoiceNO: 'ပထမ ဘီလ်နံပါတ်',
    lastInvoiceNO: 'နောက်ဆုံး ဘီလ်နံပါတ်',
    roundNo: 'အကြိမ်',
    closeAt: 'ပိတ်ချိန်',
    closeBy: 'ပိတ်သူ',
    totalCashSales: 'ငွေသားရောင်းအား စုစုပေါင်း',
    initialChange: 'အငွေအပြောင်း စတင်ပမာဏ',
    totalCashIn: 'ငွေသားဝင် စုစုပေါင်း',
    totalCashOut: 'ငွေသားထွက် စုစုပေါင်း',
    actualInDrawer: 'အံဆွဲထဲ အမှန်တကယ်',
    expectedInDrawer: 'အံဆွဲထဲ ရှိသင့်သောပမာဏ',
    difference: 'ကွာခြားချက်',
    voidBillDetail: 'ပယ်ဖျက်ဘီလ် အသေးစိတ်',
    cancelBy: 'ပယ်ဖျက်သူ',
    cancelDate: 'ပယ်ဖျက်ရက်',
    searchByEmployees: 'ဝန်ထမ်းဖြင့် ရှာပါ',
    search: 'ရှာရန်',
    timeIn: 'ဝင်ချိန်',
    timeOut: 'ထွက်ချိန်',
    time: 'အချိန်',
    hours: 'နာရီ',
    seconds: 'စက္ကန့်',
    netTotal: 'စုစုပေါင်း',
    reason: 'အကြောင်းရင်း',
    searchByProduct: 'ကုန်ပစ္စည်းဖြင့် ရှာပါ',
    sortBy: 'စီစဉ်ပုံ',
    last: 'နောက်ဆုံး',
    price: 'ကုန်ပစ္စည်းစျေးနှုန်း',
    sortByNumMin: 'အနည်းဆုံးစျေး',
    sortByNumMax: 'အများဆုံးစျေး',
    documentNo: 'စာရွက်စာတမ်းနံပါတ်',
    transactionType: 'လုပ်ဆောင်မှုအမျိုးအစား',
    updatedBy: 'အပ်ဒိတ်လုပ်သူ',
    transactionType1: 'ရောင်းချ',
    transactionType2: 'ငွေပြန်အမ်း',
    transactionType3: 'ကုန်ပစ္စည်း သွင်းရန်',
    transactionType4: 'ကုန်ပစ္စည်း ထုတ်ရန်',
    transactionType5: 'စတော့ ချိန်ညှိသွင်း',
    transactionType6: 'စတော့ ချိန်ညှိထုတ်',
    transactionType7: 'အမှတ် လဲလှယ်',
    transactionType8: 'စတော့သွင်း ဖျက်',
    transactionType9: 'စတော့ထုတ် ဖျက်',
    transactionType10: 'စတော့သွင်း ပြင်',
    transactionType11: 'စတော့ထုတ် ပြင်',
    billNo: 'ဘီလ်နံပါတ်',
    docTotal: 'စုစုပေါင်း',
    customer: 'ဖောက်သည်',
    username: 'အသုံးပြုသူအမည်',
    dateOfBill: 'ဘီလ်ရက်စွဲ',
    selectDate: 'ရက်စွဲ ရွေးပါ',
    dialogSelectCategory: 'ကျေးဇူးပြု၍ ရှာဖွေရန် အမျိုးအစား ရွေးပါ',
    dialogUpdateDocumentSuccess: 'စာရွက်စာတမ်း အပ်ဒိတ်ပြီးပါပြီ',
    dialogfound: 'ထည့်သွင်းထားသော အချက်အလက် မှားယွင်းပါသည်။',
    isVatIncluded: 'VAT ပါဝင်ပါသလား',
    vatIccludes: 'VAT',
    confirmStock: 'စတော့ အတည်ပြုရန်',
    confirm: 'အတည်ပြုရန်',
    deleteDoc: 'စာရွက်စာတမ်း ဖျက်ရန်',
    confirmUpdateDocModal: 'စတော့ စာရွက်စာတမ်း အပ်ဒိတ်လိုပါသလား။',
    confirmSaveDoc: 'စာရွက်စာတမ်း သိမ်းရန် အတည်ပြုပါ',
    confirmDeleteDoc: 'စာရွက်စာတမ်း ဖျက်ရန် အတည်ပြုပါ',
    confirmDeleteModal: 'စတော့ စာရွက်စာတမ်း ဖျက်လိုပါသလား။',
    dialogSaveDocumentSuccess: 'စာရွက်စာတမ်း သိမ်းပြီးပါပြီ',
    createStockIn: 'စတော့သွင်း ဖန်တီးရန်',
    confirmSaveDocModal: 'စတော့ စာရွက်စာတမ်း သိမ်းလိုပါသလား။',
    selectShopPlease: 'ကျေးဇူးပြု၍ ဆိုင် ရွေးပါ',
    selectProductPlease: 'ကျေးဇူးပြု၍ ကုန်ပစ္စည်း ရွေးပါ',
    duplicateProduct: 'ဤပစ္စည်းကို ရွေးချယ်ပြီးပါပြီ။',
    productInvilid: 'ရွေးချယ်ထားသော ပစ္စည်းသည် မမှန်ကန်ပါ။ ကျေးဇူးပြု၍ စီမံခန့်ခွဲသူကို ဆက်သွယ်ပါ။',
    confirmStockOut: 'စတော့ထုတ် အတည်ပြုရန်',
    dialogSaveDocumentOutSuccess: 'စာရွက်စာတမ်း သိမ်းပြီးပါပြီ',
    confirmSaveDocStockOutModal: 'စတော့ထုတ် စာရွက်စာတမ်း သိမ်းလိုပါသလား။',
    adjustDocType: 'ချိန်ညှိစာရွက်စာတမ်း အမျိုးအစား',
    adjustDocType1: 'တိုး',
    adjustDocType2: 'လျှော့',
    beforeAdjust: 'ချိန်ညှိမတိုင်မီ စတော့',
    afterAdjust: 'ချိန်ညှိပြီး စတော့',
    adjust: 'စတော့ ချိန်ညှိရန်',
    createDoucument: 'စာရွက်စာတမ်း ဖန်တီးရန်',
    transferType: 'လွှဲပြောင်းမှု အမျိုးအစား',
    transferType1: 'လွှဲသွင်း',
    transferType2: 'လွှဲထုတ်',
    new: 'အသစ်',
    finish: 'ပြီးစီး',
    refDocument: 'ကိုးကားစာရွက်စာတမ်း',
    statusDoc: 'စာရွက်စာတမ်း အခြေအနေ',
    dialogSaveTransferDocumentSuccess: 'လွှဲပြောင်းစာရွက်စာတမ်း ဖန်တီးပြီးပါပြီ',
    destinationShop: 'ဦးတည်ရာဆိုင်',
    destinationShopBranch: 'ဦးတည်ရာ ဌာနခွဲ',
    sourceBranch: 'မူလ ဌာနခွဲ',
    sourceShop: 'မူလ ဆိုင်',
    sourceAddress: 'မူလ လိပ်စာ',
    destinationAddress: 'ဦးတည်ရာ လိပ်စာ',
    saveTransfer: 'စတော့လွှဲပြောင်းမှု သိမ်းရန်',
    confirmSaveTransfer: 'စတော့လွှဲပြောင်းမှု သိမ်းလိုပါသလား။',
    savinserviceChargegDoc: 'စာရွက်စာတမ်း သိမ်းနေသည်',
    selectdestinationPlease: 'ကျေးဇူးပြု၍ ဦးတည်ရာ ဌာနခွဲ ရွေးပါ',
    validatedestinationproduct: "ဦးတည်ရာ ဌာနခွဲတွင် ကုန်ပစ္စည်း မရှိပါ",
    validateProduct: 'ကျေးဇူးပြု၍ ကုန်ပစ္စည်း ရွေးပါ',
    created_by: 'ဖန်တီးသူ',
    receive: 'လက်ခံရန်',
    updateDoc: 'စာရွက်စာတမ်း အပ်ဒိတ်',
    cancelDoc: 'စာရွက်စာတမ်း ပယ်ဖျက်',
    confirmCancelDoc: 'ဤစာရွက်စာတမ်းကို ပယ်ဖျက်လိုပါသလား။',
    cancelingDoc: 'စာရွက်စာတမ်း ပယ်ဖျက်နေသည်',
    updatingDoc: 'စာရွက်စာတမ်း အပ်ဒိတ်နေသည်',
    updateDocFail: "စာရွက်စာတမ်း အပ်ဒိတ် မလုပ်နိုင်ပါ",
    cancelDocSuccess: 'စာရွက်စာတမ်း ပယ်ဖျက်ပြီး',
    cancelDocFail: "စာရွက်စာတမ်း ပယ်ဖျက် မရပါ",
    refDocumentTransfer: 'ကိုးကားစာရွက်စာတမ်း',
    comfrimTransferIn: 'စတော့လွှဲသွင်း အတည်ပြုရန်',
    dilogcomfrimTransferIn: 'စတော့လွှဲသွင်း စာရွက်စာတမ်းကို အတည်ပြုလိုပါသလား။',
    transferInDetail: 'စတော့လွှဲပြောင်းမှု အသေးစိတ်',
    totalNet: 'အသားတင် စုစုပေါင်း',
    confirmAdjust: 'စတော့ချိန်ညှိ အတည်ပြုရန်',
    createStockOut: 'စတော့ထုတ် ဖန်တီးရန်',
    favorite: 'စိတ်ကြိုက်',
    isOnScreen: 'မျက်နှာပြင်ပေါ် ပြသရန်',
    negotiatePrice: 'ညှိနှိုင်းစျေး',
    productTypeP: 'ယေဘုယျ ကုန်ပစ္စည်း',
    productTypeBOM: 'ပေါင်းစပ်ကုန်ပစ္စည်း',
    productTypeSN: 'Serial ကုန်ပစ္စည်း',
    productTypeSV: 'ဝန်ဆောင်မှု (စတော့မရှိ)',
    productPLU: 'အခြား ထုပ်ပိုးအရွယ်အစား',
    productBOM: 'ကုန်ကြမ်း',
    productSN: 'Serial Number',
    morePrice: 'အခြားစျေးနှုန်း',
    cost: 'ကုန်ကျစရိတ်',
    quantityPrice: 'အရေအတွက်',
    exceedUc: 'စျေးနှုန်း',
    changeImg: 'ပုံ ပြောင်းရန်',
    addProduct: 'ကုန်ပစ္စည်း ထည့်ပါ',
    selectImg: 'ပုံ ရွေးပါ',
    deleteImg: 'ပုံ ဖျက်ပါ',
    selectImgFromPC: 'ကွန်ပျူတာမှ ပုံ ရွေးပါ',
    confirmSaveImgDialog: 'ကုန်ပစ္စည်း သိမ်းလိုပါသလား။',
    confirmSaveImg: 'ကုန်ပစ္စည်း သိမ်းရန် အတည်ပြုပါ။',
    addPrice: 'စျေးနှုန်း ထည့်ပါ',
    editPrice: 'စျေးနှုန်း ပြင်ရန်',
    dialigDeleteProduct: 'ကုန်ပစ္စည်း ဖျက်လိုပါသလား။',
    confirmDeleteProduct: 'ဤကုန်ပစ္စည်း ဖျက်ရန် အတည်ပြုပါ။',
    productType: 'ကုန်ပစ္စည်း အမျိုးအစား',
    countProduct: 'ကုန်ပစ္စည်း အရေအတွက်',
    addUnit: 'ယူနစ် ထည့်ပါ',
    editUnit: 'ယူနစ် ပြင်ရန်',
    active: 'ဖွင့်ထားသည်',
    inactive: 'ပိတ်ထားသည်',
    confirmSaveUnitDialog: 'ယူနစ် သိမ်းလိုပါသလား။',
    confirmSaveUnit: 'ဤယူနစ် သိမ်းရန် အတည်ပြုပါ။',
    dialigDeleteUnit: 'ယူနစ် ဖျက်လိုပါသလား။',
    confirmDeletUnit: 'ဤယူနစ် ဖျက်ရန် အတည်ပြုပါ။',
    confirmSaveCategoryDialog: 'အမျိုးအစား သိမ်းလိုပါသလား။',
    confirmSaveCategory: 'ဤအမျိုးအစား သိမ်းရန် အတည်ပြုပါ။',
    dialigDeleteCategory: 'အမျိုးအစား ဖျက်လိုပါသလား။',
    confirmDeletCategory: 'အမျိုးအစား ဖျက်ရန် အတည်ပြုပါ။',
    addCategory: 'အမျိုးအစား ထည့်ပါ',
    editCategory: 'အမျိုးအစား ပြင်ရန်',
    bgColor: 'နောက်ခံအရောင်',
    selectbgColor: 'နောက်ခံအရောင် ရွေးပါ',
    validateCategoryname: 'ကျေးဇူးပြု၍ အမျိုးအစားအမည် ထည့်ပါ။',
    sequence: 'အစဉ်',
    enterProduct: 'ကျေးဇူးပြု၍ ကုန်ပစ္စည်းအမည် ထည့်ပါ။',
    enterPrice: 'ကျေးဇူးပြု၍ ကုန်ပစ္စည်းစျေးနှုန်း ထည့်ပါ။',
    selectCategory: 'ကျေးဇူးပြု၍ ကုန်ပစ္စည်း အမျိုးအစား ရွေးပါ။',
    selectUnit: 'ကျေးဇူးပြု၍ ကုန်ပစ္စည်း ယူနစ် ရွေးပါ။',
    confirmSaveProduct: 'ဤကုန်ပစ္စည်း သိမ်းလိုပါသလား။',
    confirmSaveProductPrice: 'အခြားစျေးနှုန်း သိမ်းလိုပါသလား။',
    validatepackQty: 'ကျေးဇူးပြု၍ စျေးနှုန်း/ယူနစ် ထည့်ပါ။',
    validatepackUc: 'ကျေးဇူးပြု၍ စျေးနှုန်း ထည့်ပါ။',
    validatePRU: 'ဒေတာ ထပ်နေပါသည်၊ ကျေးဇူးပြု၍ ထပ်ထည့်ပါ။',
    createProductSuccess: 'ကုန်ပစ္စည်း ဖန်တီးပြီးပါပြီ',
    addSerial: 'Serial ထည့်ပါ',
    add: 'ထည့်ပါ',
    createSerial: 'Serial Number ဖန်တီးပါ',
    available: 'ရောင်းရန် အဆင်သင့်',
    soldOut: 'ကုန်ဆုံးပြီ',
    deleteSuccess: 'ဖျက်ပြီးပါပြီ',
    enterSerial: 'ကျေးဇူးပြု၍ Serial Number ထည့်ပါ',
    confirmSaveSerial: 'ဤ Serial Number သိမ်းလိုပါသလား။',
    confirmDelete: 'ဤ Serial Number ဖျက်လိုပါသလား။',
    addProductPLU: 'ထုပ်ပိုးအရွယ်အစား ထည့်ပါ',
    img: 'ပုံ',
    SKURatio: 'အချိုး',
    editProductPLU: 'ထုပ်ပိုးအရွယ်အစား ပြင်ရန်',
    enterSKURatio: 'ကျေးဇူးပြု၍ အချိုး ထည့်ပါ',
    comfrimDeletePLU: 'ဤထုပ်ပိုးအရွယ်အစား ဖျက်လိုပါသလား။',
    useStepPrice: 'အဆင့်စျေးနှုန်း သုံးပါ',
    addBOM: 'ကုန်ကြမ်း ထည့်ပါ',
    confirmSaveBOM: 'ကုန်ကြမ်း သိမ်းလိုပါသလား။',
    user: 'အသုံးပြုသူ',
    userDetail: 'အသုံးပြုသူ အသေးစိတ်',
    planDetail: 'အစီအစဉ် အသေးစိတ်',
    currentPlan: 'လက်ရှိ အစီအစဉ်',
    expireDate: 'သက်တမ်းကုန်ရက်',
    startDate: 'စတင်ရက်',
    dialogSignOut: 'ထွက်လိုပါသလား။',
    confirmSignOut: 'ထွက်ရန် အတည်ပြုပါ',
    countMember: 'အဖွဲ့ဝင်အားလုံး',
    addMenber: 'အဖွဲ့ဝင် ထည့်ပါ',
    searchMember: 'အမည်၊ အီးမေးလ်နှင့် ဖုန်းဖြင့် ရှာပါ',
    dateOfMember: 'အဖွဲ့ဝင်ဖြစ်သည့်ရက်',
    recentVisit: 'နောက်ဆုံး ဝင်ရောက်ချိန်',
    memberName: 'အဖွဲ့ဝင်အမည်',
    email: 'အီးမေးလ်',
    paymentTotal: 'ငွေပေးချေမှု စုစုပေါင်း',
    point: 'အမှတ်',
    pointtxt: 'အမှတ်',
    postalCode: 'စာတိုက်သင်္ကေတ',
    saveing: 'သိမ်းနေသည်...',
    edit: 'ပြင်ရန်',
    editMember: 'အဖွဲ့ဝင် ပြင်ရန်',
    deleteing: 'ဖျက်နေသည်...',
    dialogDeleteMember: 'အဖွဲ့ဝင် ဖျက်လိုပါသလား',
    confirmDeleteMember: 'ဖျက်ရန် အတည်ပြုပါ',
    valtdateMember: 'ကျေးဇူးပြု၍ အချက်အလက် ဖြည့်ပါ',
    createMemberSuccess: 'အဖွဲ့ဝင် ထည့်ပြီးပါပြီ!!',
    updateMemberSuccess: 'အဖွဲ့ဝင် ပြင်ပြီးပါပြီ!!',
    deleteMemberSuccess: 'အဖွဲ့ဝင် ဖျက်ပြီးပါပြီ!!',
    onhandQtyMin: 'အနည်းဆုံး လက်ကျန်',
    onhandQtyMax: 'အများဆုံး လက်ကျန်',
    onhandQtySort: 'လက်ကျန်',
    showProductAll: 'ကုန်ပစ္စည်း အားလုံး',
    updateAt: 'နောက်ဆုံး အပ်ဒိတ်',
    sortName: 'အမည်',
    stockUnit: 'ကုန်ကျစရိတ်/ယူနစ်',
    deleteCategory: 'အမျိုးအစား ဖျက်ပြီး',
    selectd: 'ရွေးပါ',
    searchProduct: 'ကုန်ပစ္စည်း ရှာပါ',
    reset: 'ပြန်စပါ',
    selectdProduct: 'ကုန်ပစ္စည်း ရွေးပါ',
    information: 'အချက်အလက်',
    adjustStockList: 'စတော့ချိန်ညှိ ကုန်ပစ္စည်းစာရင်း',
    adjustDetail: 'စတော့ချိန်ညှိ စာရင်းသို့ ကုန်ပစ္စည်း ထည့်ပြီး သတ်မှတ်ပါ',
    transferoutList: 'စတော့လွှဲပြောင်း ကုန်ပစ္စည်းစာရင်း',
    addProductTransfer: 'စတော့လွှဲပြောင်း စာရင်းသို့ ကုန်ပစ္စည်း ထည့်ပြီး သတ်မှတ်ပါ',
    transferDetail: 'စတော့ထုတ် စာရင်းသို့ ကုန်ပစ္စည်း ထည့်ပြီး သတ်မှတ်ပါ',
    transferinList: 'စတော့သွင်း စာရင်းသို့ ကုန်ပစ္စည်း ထည့်ပြီး သတ်မှတ်ပါ',
    stockOutList: 'စတော့ထုတ် ကုန်ပစ္စည်း',
    addstockOutList: 'စတော့ထုတ် စာရင်းသို့ ကုန်ပစ္စည်း ထည့်ပြီး သတ်မှတ်ပါ',
    stockinList: 'စတော့သွင်း ကုန်ပစ္စည်း',
    addProductStockin: 'စတော့သွင်း စာရင်းသို့ ကုန်ပစ္စည်း ထည့်ပြီး သတ်မှတ်ပါ',
    checkCount: 'စတော့ စစ်ဆေးရန်',
    createAdjustStock: 'စတော့ချိန်ညှိ ဖန်တီးရန်',
    memberDetail: 'အဖွဲ့ဝင် အချက်အလက်',
    package: 'အစီအစဉ် အသေးစိတ်',
    startPackate: 'အစီအစဉ် စတင်',
    endPackate: 'အစီအစဉ် ကုန်ဆုံး',
    name: 'အမည်',
    productImg: 'ကုန်ပစ္စည်းပုံ',
    fistname: 'နာမည်',
    lastname: 'မျိုးရိုးအမည်',
    saveMember: 'အချက်အလက် သိမ်းရန်',
    confirmSaveMember: 'အဖွဲ့ဝင် သိမ်းလိုပါသလား',
    yesOrNo: 'ဟုတ် သို့မဟုတ် မဟုတ်',
    totaValue: 'စုစုပေါင်း',
    deleteMember: 'အဖွဲ့ဝင် ဖျက်ရန်',
    frequently: 'မကြာခဏ ဝယ်ယူသော ကုန်ပစ္စည်း',
    recentPurchase: 'နောက်ဆုံး ဝယ်ယူမှု',
    paymentDescription: 'ငွေပေးချေမှု ဖော်ပြချက်',
    validateInfomation: 'ကျေးဇူးပြု၍ အချက်အလက် ထည့်ပါ',
    validateTel: 'ဖုန်းနံပါတ် မှားယွင်းပါသည်',
    validateOTP: 'OTP မှားယွင်းပါသည်',
    validateEmail: 'အီးမေးလ် မှားယွင်းပါသည်',
    saveSuccess: 'သိမ်းပြီးပါပြီ',
    txtcustomer: 'ဖောက်သည်',
    customerName: 'ဖောက်သည်အမည်',
    customerCount: 'ဖောက်သည် အရေအတွက်',
    addCustomer: 'ဖောက်သည် ထည့်ပါ',
    permissionManage: 'ခွင့်ပြုချက် စီမံခန့်ခွဲမှု',
    mainMenu: 'ပင်မမီနူး',
    page: 'စာမျက်နှာ',
    show: 'ပြသ',
    delete: 'ဖျက်ရန်',
    administratorTools: 'စီမံခန့်ခွဲသူ ကိရိယာများ',
    deviceName: 'စက်အမည်',
    lastSyncProduct: 'နောက်ဆုံး Sync',
    version: 'ဗားရှင်း',
    posstatus: 'အခြေအနေ',
    posNumber: 'POS နံပါတ်',
    titleSilomconnect: 'ဝန်ဆောင်မှုများဖြင့် ရောင်းအား မလွတ်စေပါနှင့်',
    updateSilom: 'နေ့စဥ် ရောင်းအားကို LINE မှ အခမဲ့ အပ်ဒိတ်လုပ်ပါ',
    addfriend: 'သူငယ်ချင်း ထည့်ပါ',
    enterToReciveService: 'ဝန်ဆောင်မှုအတွက် ကုဒ်ရယူရန် နှိပ်ပါ။',
    verifyCodeToUsed: 'စနစ်ကို စတင်အသုံးပြုရန်။ အထောက်အထား စစ်ဆေးရန် ကုဒ်ရယူနိုင်ပါသည်။',
    verifyfivemin: 'စစ်ဆေးကုဒ်ကို ၅ မိနစ်အတွင်း အသုံးပြုနိုင်ပါသည်။',
    yourVertify: 'သင့်စစ်ဆေးကုဒ်မှာ',
    pressCode: 'ကုဒ်ရယူရန် နှိပ်ပါ',
    exCode: 'ကုဒ် သက်တမ်းကုန်ချိန်',
    sessionEx: 'ဝင်ရောက်မှု သက်တမ်းကုန်ပါပြီ။ ကျေးဇူးပြု၍ ထပ်မံဝင်ရောက်ပါ။',
    refresh: 'ပြန်လည်ဖွင့်ပါ',
    selectedFile: 'ဖိုင် ရွေးပါ',
    fileSize: 'ဖိုင်အရွယ်အစား 2 MB ထက်မကျော်ရ။',
    isBeingToUsed: 'အသုံးပြုနေသည်',
    notInUse: 'အသုံးမပြုပါ',
    delete: 'ဖျက်ရန်',
    confirmUpdateInformation: 'အချက်အလက် အပ်ဒိတ် အတည်ပြုပါ',
    memberCount: 'အရေအတွက်',
    orderMachine: 'မှာယူရေး စက်',
    textMember: 'အဖွဲ့ဝင်',
    manageShop: 'ဆိုင်အချက်အလက် စီမံခန့်ခွဲမှု',
    lansetting: 'ဆိုင် ဘာသာစကားနှင့် အချိန်ဇုန် သတ်မှတ်ခြင်း',
    timezoneSetiing: 'ဆိုင်အတွက် အချိန်ဇုန် သတ်မှတ်ခြင်း',
    deliveryProviderSetting: 'ဆိုင်အတွက် ပို့ဆောင်ရေး ဝန်ဆောင်မှုပေးသူများ',
    toolsSetting: 'ဆိုင်အတွက် POS စက် စီမံခန့်ခွဲရန်',
    checkStockPLU: 'ကုန်ပစ္စည်း လက်ကျန် < 0',
    searching: 'ရှာဖွေနေသည်',
    allProduct: 'ကုန်ပစ္စည်း အားလုံး',
    foundProductOnhand: 'လက်ကျန် < 0 ရှိသော ကုန်ပစ္စည်း တွေ့ရှိ',
    confirmAdjustBefor: 'စနစ်ဖြင့် အလိုအလျောက် ချိန်ညှိလိုပါသလား။',
    requireAdjust: 'ဟုတ်',
    imrequireAdjust: 'မဟုတ်',
    islimitItemTodoc: 'စာရွက်စာတမ်း ၁ ခုလျှင် အများဆုံး ၂၀၀ ပစ္စည်း ရွေးနိုင်ပါသည်။',
    barcodePrint: 'ဘားကုဒ် ပုံနှိပ်ရန်',
    printEx: 'ပုံနှိပ် & နမူနာ',
    print: 'ပုံနှိပ်',
    downloadAndExport: 'ဒေါင်းလုဒ်လုပ်ပြီး ပုံနှိပ်ပါ',
    selectFormat: 'စာရွက်ပုံစံ ရွေးပါ',
    peperFormat: 'စာရွက်ပုံစံ',
    optional: 'ရွေးချယ်စရာ',
    standardA427: 'A4 စံ : ၂၇ ခု / စာမျက်နှာ',
    standardA450: 'A4 စံ : ၅၂ ခု / စာမျက်နှာ',
    standardA460: 'A4 စံ : ၆၀ ခု / စာမျက်နှာ',
    standardA556: 'A4 စံ : ၅၆ ခု / စာမျက်နှာ (စတစ်ကာ အရွယ်:A5)',
    standardA550: 'A5 စာရွက် : ၅၂ ခု / စာမျက်နှာ',
    standardA560: 'A5 စာရွက် : ၆၀ ခု / စာမျက်နှာ',
    countBarcode: 'ဘားကုဒ် အရေအတွက်',
    barcode: 'ဘားကုဒ်',
    setFontsize: 'ဖောင့် သတ်မှတ်ခြင်း',
    accessPermissionDes: 'အသုံးပြုသူများအတွက် ခွင့်ပြုချက် သတ်မှတ်ပါ။',
    deleteUser: 'အသုံးပြုသူ ဖျက်ရန် အတည်ပြုပါ',
    confirmDeleteUser: 'အသုံးပြုသူ ဖျက်လိုပါသလား။',
    passAtless: 'စကားဝှက် အနည်းဆုံး ၆ လုံး ရှိရပါမည်။',
    inValidPass: 'စကားဝှက် မှားယွင်းပါသည်',
    createBy: 'ဖန်တီးသူ',
    adjustAutoDes: "စနစ်ဖြင့် အလိုအလျောက် အပ်ဒိတ်မလုပ်လိုပါက ကုန်ပစ္စည်းလက်ကျန် မှားယွင်းနိုင်ပါသည်။",
    addUser: 'အသုံးပြုသူ ထည့်ပါ',
    isMenu: 'ဖောက်သည်မီနူးတွင် ပြသရန်',
    menuSmart: 'ကုန်ပစ္စည်းမီနူး သတ်မှတ်ရန်',
    smartSettingTitle: 'မီနူး သတ်မှတ်ခြင်း',
    smartSetting: 'Silom CRM အတွက် မီနူး သတ်မှတ်ရန်',
    confirmEnable: 'မီနူး ဖွင့်လိုပါသလား။',
    confirmDisEnable: 'မီနူး ပိတ်လိုပါသလား။',
    confirmSelfOrderEnable: 'ကိုယ်တိုင်မှာယူ မီနူး ဖွင့်လိုပါသလား။',
    confirmSelfOrderDisable: 'ကိုယ်တိုင်မှာယူ မီနူး ပိတ်လိုပါသလား။',
    enable: 'ဖွင့်',
    disable: 'ပိတ်',
    usabilityStatus: 'ဖွင့်ထားသည်',
    manageSmartOnProduct: 'ဤစာမျက်နှာတွင် ဖောက်သည်မီနူးတွင် ပြသလိုသော ကုန်ပစ္စည်းစာရင်းကို "ထည့်/ပြင်" နိုင်ပါသည်။',
    manageSmartOnCategory: 'ဤစာမျက်နှာတွင် ဖောက်သည်မီနူးတွင် ပြသလိုသော အမျိုးအစားစာရင်းကို "ထည့်/ပြင်" နိုင်ပါသည်။',
    turnonSmart: 'နှင့် မီနူးကို ဖွင့်ပါ',
    manageShopDes: 'အသုံးပြုသူ လမ်းညွှန်ကို ကိုးကားနိုင်ပါသည် -',
    desSmartMenu: 'ဖောက်သည်များ လွယ်ကူစွာ ဝင်ရောက်နိုင်ပြီး ကိုယ်တိုင် မှာယူနိုင်ရန် Line ပေါ်တွင် E-menu ပြသရန် ကုန်ပစ္စည်းမီနူး သတ်မှတ်ပါ။',
    link: 'လင့်ခ်',
    createTranferOut: 'လွှဲထုတ် စာရွက်စာတမ်း ဖန်တီးရန်',
    roundingValue: 'ဝိုင်းချခြင်း',
    limitItems: 'ကုန်ပစ္စည်း အများဆုံး ၂၀၀ ခု ရွေးနိုင်ပါသည်',
    IncomeCategory: 'ဝင်ငွေ',
    ExpenseCategory: 'ထွက်ငွေ',
    saveBy: 'သိမ်းသူ',
    saveDate: 'သိမ်းရက်',
    drawerCate: 'အမျိုးအစားများ',
    openingHours: 'ဖွင့်ချိန်',
    shopLocation: 'ဆိုင်တည်နေရာ',
    sunday: 'တနင်္ဂနွေ',
    monday: 'တနင်္လာ',
    tuesday: 'အင်္ဂါ',
    wednesday: 'ဗုဒ္ဓဟူး',
    thursday: 'ကြာသပတေး',
    friday: 'သောကြာ',
    saturday: 'စနေ',
    lat: 'လတ္တီကျူ',
    lng: 'လောင်ဂျီကျူ',
    shopCoverSetting: 'ဆိုင် မျက်နှာဖုံး သတ်မှတ်ခြင်း',
    shopCoverSettingDes: 'ဖောက်သည်မျက်နှာပြင်တွင် ပြသရန် ဆိုင်မျက်နှာဖုံး သတ်မှတ်ပါ',
    locationSettingDes: 'တည်နေရာ သတ်မှတ်ခြင်း',
    updatelocation: 'တည်နေရာ အပ်ဒိတ်',
    searchLocation: 'တည်နေရာ ရှာပါ',
    imaginaryLine: 'နယ်နိမိတ်မျဉ်း',
    openingHoursDes: 'ဆိုင်အတွက် ဖွင့်ချိန် သတ်မှတ်ပါ',
    paymentDescriptionConfig: 'ငွေပေးချေမှုနည်းလမ်း ရွေးပါ',
    creditCard: 'ခရက်ဒစ်ကတ်',
    promptPay: 'Promptpay',
    coupon: 'ကူပွန်',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: 'လ',
    dayMY: 'ရက်စွဲ',
    item: 'ပစ္စည်း',
    byStockIn: 'စတော့သွင်း',
    stockOutOther: 'အခြား',
    drawerSales: 'ရောင်းအား',
    sumIncomeExpenses: 'ဝင်ငွေ-ထွက်ငွေ အကျဉ်းချုပ်',
    incomeOther: 'အခြား ဝင်ငွေ',
    loss: 'အရှုံး',
    grossProfit: 'အကြမ်းဖျင်း အမြတ်',
    newUser: 'အသုံးပြုသူ အသစ်',
    userType: 'အသုံးပြုသူ အမျိုးအစား',
    password: 'စကားဝှက်',
    confirmPassword: 'စကားဝှက် အတည်ပြုပါ',
    ParticipatingProducts: 'ကုန်ပစ္စည်း ရွေးပါ',
    descriptionSilomOrder: 'order.silompos.com အတွက် ကုန်ပစ္စည်း ရွေးပါ',
    cashierManagement: 'ငွေကိုင် စီမံခန့်ခွဲမှု',
    cashierManageButton: 'စီမံရန်',
    cashierUsernamePassword: 'အသုံးပြုသူအမည်/စကားဝှက် သတ်မှတ်ပါ',
    cashierCRUDDescription: 'order.silompos.com ဝင်ရောက်ရန်',
    password: 'စကားဝှက်',
    placeholderPassword: 'အနည်းဆုံး ၆ လုံး',
    resetPassword: 'စကားဝှက် ပြန်သတ်မှတ်ပါ',
    oldPassword: 'စကားဝှက်ဟောင်း',
    oldPasswordPlaceholder: 'စကားဝှက်ဟောင်း',
    newPassword: 'စကားဝှက်အသစ်',
    purchaseDetail: 'ဝယ်ယူမှု အသေးစိတ်',
    uploadImage: 'ပုံ တင်ရန်',
    keyword: 'အဓိကစကားလုံး',
    firstname: 'နာမည်',
    lastname: 'မျိုးရိုးအမည်',
    province: 'ပြည်နယ်/တိုင်း',
    district: 'ခရိုင်',
    subdistrict: 'မြို့နယ်',
    addressNumber: 'လိပ်စာ',
    setAsDefaultAddress: 'ပုံသေ လိပ်စာအဖြစ် သတ်မှတ်ပါ',
    setAsTaxAddress: 'အခွန်လိပ်စာအဖြစ် သတ်မှတ်ပါ',
    setAsShippingAddress: 'ပို့ဆောင်ရေးလိပ်စာအဖြစ် သတ်မှတ်ပါ',
    contact: 'ဆက်သွယ်ရန်',
    setAsDefault: 'ပုံသေအဖြစ် သတ်မှတ်ပါ',
    addressLists: 'လိပ်စာ စာရင်း',
    default: 'ပုံသေ',
    taxAddress: 'အခွန်ပြေစာ',
    shippingAddress: 'ပို့ဆောင်ရေး',
    addAddress: 'ထည့်ပါ',
    createdAt: 'ဖန်တီးချိန်',
    updatedAt: 'အပ်ဒိတ်ချိန်',
    by: 'ဖြင့်',
    readyForSale: 'ရောင်းရန် အဆင်သင့်',
    sold: 'ရောင်းပြီး',
    delete: 'ဖျက်ရန်',
    items: 'ပစ္စည်းများ',
    itemDiscount: 'ပစ္စည်း လျှော့စျေး',
    failedToSave: 'သိမ်းဆည်း မအောင်မြင်ပါ!',
    dateOfBirth: 'မွေးသက္ကရာဇ်',
    menu: 'မီနူး',
    dashboardMenu: 'ဒက်ရှ်ဘုတ်',
    transactionMenu: 'လုပ်ဆောင်မှု',
    currentBillMenu: 'လက်ရှိ ဘီလ်',
    reportMenu: 'အစီရင်ခံစာ',
    orderDeviceMenu: 'မှာယူရေး စက်',
    memberMenu: 'အဖွဲ့ဝင်',
    inventoryMenu: 'စတော့',
    productMenu: 'ကုန်ပစ္စည်း',
    selfOrderMenu: 'ရောင်းချမှု ချန်နယ်',
    settingMenu: 'ဆက်တင်',
    salesReportByDate: 'ရက်စွဲအလိုက် ရောင်းအား',
    salesReportByBill: 'ဘီလ်အသေးစိတ်အလိုက် ရောင်းအား',
    salesQuantitySummaryByProductReport: 'ကုန်ပစ္စည်းအလိုက် ရောင်းအား',
    quantitySummaryByPLUReport: 'ကုန်ပစ္စည်းအလိုက် ရောင်းအား (PLU)',
    nonSellingProduct: 'မရောင်းရသော ကုန်ပစ္စည်းများ',
    salesSummaryByCashierReport: 'ငွေကိုင်အလိုက် ရောင်းအား',
    salesSummaryByCategoryReport: 'အမျိုးအစားအလိုက် ရောင်းအား',
    paymentReport: 'ငွေပေးချေမှု',
    salesTaxReport: 'ရောင်းအား အခွန်',
    drawerReport: 'အံဆွဲ',
    voidBillReport: 'ပယ်ဖျက်ဘီလ်',
    timesheetReport: 'အချိန်စာရင်း',
    stockInByListReport: 'ကုန်ပစ္စည်းအလိုက် စတော့သွင်း',
    stockOutByListReport: 'ကုန်ပစ္စည်းအလိုက် စတော့ထုတ်',
    nonAdjustStockProductReport: 'စတော့ မချိန်ညှိရသေးသော ကုန်ပစ္စည်း',
    exportProductReport: 'ကုန်ပစ္စည်း တင်ပို့ရန်',
    salesSummaryByOrderReport: 'မှာယူရေးစက်အလိုက်',
    salesSummaryProductByOrderReport: 'ကုန်ပစ္စည်းအလိုက်',
    voidBillByOrderReport: 'ပယ်ဖျက်ဘီလ်',
    inventoryReport: 'စတော့ အစီရင်ခံစာ',
    inventoryReportByPLU: 'PLU အလိုက် စတော့ အစီရင်ခံစာ',
    inventoryReportBySerial: 'Serial No. အလိုက် စတော့ အစီရင်ခံစာ',
    stockMovement: 'စတော့ ရွေ့လျားမှု',
    stockInDocument: 'စတော့သွင်း စာရွက်စာတမ်း',
    stockOutDocument: 'စတော့ထုတ် စာရွက်စာတမ်း',
    adjustStockDocument: 'စတော့ချိန်ညှိ စာရွက်စာတမ်း',
    selfOrder: 'ကိုယ်တိုင် မှာယူ',
    cashier: 'ငွေကိုင်',
    permission: 'ခွင့်ပြုချက်',
    menuSetting: 'မီနူး သတ်မှတ်ခြင်း',
    management: {
        txtManagement: 'စီမံခန့်ခွဲမှု',
        user: 'အကောင့်',
        shopBranch: 'ဆိုင်နှင့် ဌာနခွဲ',
        productManagement: 'ကုန်ပစ္စည်း',
        unitManagement: 'ယူနစ်',
        categorytManagement: 'အမျိုးအစား',
        inventory: 'စတော့',
        stockIn: 'စတော့သွင်း',
        stockOut: 'စတော့ထုတ်',
        adjustStock: 'စတော့ချိန်ညှိ',
        checkStock: 'စတော့ စစ်ဆေးရန်',
        stockMovement: 'စတော့ ရွေ့လျားမှု',
        transferStock: 'စတော့ လွှဲပြောင်း',
        reportByPLU: 'PLU အလိုက် စတော့ အစီရင်ခံစာ',
        reportBySKU: 'စတော့ အစီရင်ခံစာ',
        txtreportBySKU: 'စတော့ အစီရင်ခံစာ',
        txtreportByPLU: 'PLU အလိုက် စတော့ အစီရင်ခံစာ',
        stockInDoc: 'စတော့သွင်း စာရွက်စာတမ်း',
        stockOutDoc: 'စတော့ထုတ် စာရွက်စာတမ်း',
        adjustStockDoc: 'စတော့ချိန်ညှိ စာရွက်စာတမ်း',
        transferStockDoc: 'စတော့လွှဲပြောင်း စာရွက်စာတမ်း',
        transferStockInDoc: 'စတော့လွှဲသွင်း စာရွက်စာတမ်း',
        transferStockOutDoc: 'စတော့လွှဲထုတ် စာရွက်စာတမ်း',
    },
    report: {
        dashboard: 'ဒက်ရှ်ဘုတ်',
        transaction: 'လုပ်ဆောင်မှုများ',
        currentbill: 'လက်ရှိ ဘီလ်',
        daily: 'ရက်စွဲအလိုက်',
        txtdaily: 'ရက်စွဲအလိုက် ရောင်းအား အစီရင်ခံစာ',
        dailyDes: 'ရက်စွဲအလိုက် ရောင်းအား အသေးစိတ်',
        sellbyProduct: 'ဘီလ်အသေးစိတ်အလိုက်',
        txtsellbyProduct: 'ဘီလ်အသေးစိတ်အလိုက် ရောင်းအား အစီရင်ခံစာ',
        sku: 'ကုန်ပစ္စည်းအလိုက်',
        txtsku: 'ကုန်ပစ္စည်းအလိုက် ရောင်းအား အစီရင်ခံစာ',
        plu: 'ကုန်ပစ္စည်းအလိုက် (PLU)',
        textPlu: 'ကုန်ပစ္စည်းအလိုက် ရောင်းအား အစီရင်ခံစာ (PLU)',
        paymentreport: 'ငွေပေးချေမှု အစီရင်ခံစာ',
        txtpaymentreport: 'ငွေပေးချေမှု အစီရင်ခံစာ',
        timesheet: 'အချိန်စာရင်း',
        txtTimesheet: 'အချိန်စာရင်း အစီရင်ခံစာ',
        unsell: 'မရောင်းရသော ကုန်ပစ္စည်းများ',
        txtUnsell: 'မရောင်းရသော ကုန်ပစ္စည်းများ',
        byCategory: 'အမျိုးအစားအလိုက်',
        txtbyCategory: 'အမျိုးအစားအလိုက် ရောင်းအား အစီရင်ခံစာ',
        byCashier: 'ငွေကိုင်အလိုက်',
        txtbyCashier: 'ငွေကိုင်အလိုက် ရောင်းအား အစီရင်ခံစာ',
        salesTax: 'ရောင်းအား အခွန် အစီရင်ခံစာ',
        txtSalesTax: 'ရောင်းအား အခွန် အစီရင်ခံစာ',
        voidbill: 'ပယ်ဖျက်ဘီလ်',
        txtvoidbill: 'ပယ်ဖျက်ဘီလ် အစီရင်ခံစာ',
        closedSale: 'ရောင်းချမှု ပိတ်',
        txtCloseSale: 'အံဆွဲ အစီရင်ခံစာ',
        salesByOrder: 'ရောင်းအား အကျဉ်းချုပ်',
        productByOrder: 'ကုန်ပစ္စည်းအလိုက်',
        unsalesByOrder: 'ပယ်ဖျက်ဘီလ်',
        txtDeliveryRoport: 'ပို့ဆောင်ရေးအလိုက် ငွေပေးချေမှု အစီရင်ခံစာ',
        txtCustomReport: 'စိတ်ကြိုက် ငွေပေးချေမှု အစီရင်ခံစာ',
        txtSalesByOrder: 'မှာယူရေးစက်အလိုက် ကုန်ပစ္စည်း ရောင်းအား',
        txtDailyOrder: 'မှာယူရေးစက်အလိုက် ရောင်းအား အစီရင်ခံစာ',
        txtViodOrder: 'မှာယူရေးစက်အလိုက် ပယ်ဖျက်ဘီလ်',
        nonadjust: 'စတော့ မချိန်ညှိရသေးသော ကုန်ပစ္စည်း',
        txtnonadjust: 'စတော့ မချိန်ညှိရသေးသော ကုန်ပစ္စည်း အစီရင်ခံစာ',
        stockInReport: 'ကုန်ပစ္စည်းအလိုက် စတော့သွင်း အစီရင်ခံစာ',
        stockOutReport: 'ကုန်ပစ္စည်းအလိုက် စတော့ထုတ် အစီရင်ခံစာ',
        stockIn: 'ကုန်ပစ္စည်းအလိုက် စတော့သွင်း',
        stockOut: 'ကုန်ပစ္စည်းအလိုက် စတော့ထုတ်',
        exportProduct: 'ကုန်ပစ္စည်း တင်ပို့ရန်',
        txtExportProduct: 'ကုန်ပစ္စည်း တင်ပို့ အစီရင်ခံစာ',
        cashDrawer: 'အံဆွဲ',
        txtCashDrawerr: 'ငွေသား စီမံခန့်ခွဲမှု အစီရင်ခံစာ',
        cashRevenue: 'ငွေသား ဝင်ငွေ',
    },
    drawer: {
        cashDrawer: 'အံဆွဲ',
        txtCashDrawerr: 'ငွေသား စီမံခန့်ခွဲမှု အစီရင်ခံစာ',
        cashRevenue: 'ဝင်ငွေ-ထွက်ငွေ အကျဉ်းချုပ်',
        txtcashRevenue: 'ဝင်ငွေ-ထွက်ငွေ အကျဉ်းချုပ် အစီရင်ခံစာ',
    },
    member: {
        txtmember: 'အဖွဲ့ဝင်',
        register: 'ဆိုင်မှတ်ပုံတင် (LINE OA)',
        loyaltyPoint: 'အမှတ်စုဆောင်းခြင်း',
        storeCredit: 'ဆိုင်ခရက်ဒစ်',
        deal: 'ဒီးလ်',
        giftVoucher: 'လက်ဆောင်ဘောက်ချာ',
        referral: 'ဖိတ်ခေါ်ခြင်း',
        crm: 'Silom CRM',
    },
    unableStockDescription: 'စာရွက်စာတမ်း ဖန်တီးပြီးနောက် စတော့ အပ်ဒိတ်လုပ်ထားသဖြင့် ကုန်ပစ္စည်း ပြင်ဆင်၍မရပါ။',
    noItem: 'ပစ္စည်း မရှိပါ',
    enterProductName: 'ကုန်ပစ္စည်းအမည် ထည့်ပါ',
    ByCategory: 'အမျိုးအစားအလိုက်',
    ByCategoryDetail: 'အမျိုးအစားအလိုက် အသေးစိတ်',
    maximum: 'အများဆုံး',
    selectZone: 'ဇုန် ရွေးပါ',
    minimum: 'အနည်းဆုံး',
    unlimited: 'အကန့်အသတ်မရှိ',
    startTime: 'စတင်ချိန်',
    endTime: 'ပြီးဆုံးချိန်',

    "errorMessages": {
        "qrExpired": "QR Code သက်တမ်းကုန်ပါပြီ",
        "qrNotFound": "QR Code မတွေ့ပါ",
        "paymentSuccess": "ငွေပေးချေမှု အောင်မြင်",
        "invalidQrType": "QR Code အမျိုးအစား မမှန်ကန်ပါ",
        "tableMoved": "စားပွဲ ပြောင်းပြီးပါပြီ",
        "receiptVoided": "ပြေစာ ပယ်ဖျက်ပြီးပါပြီ"
    },
    "errorDescriptions": {
        "qrExpired": "သင်အသုံးပြုသော QR Code သက်တမ်းကုန်ပါပြီ။ <br>ကျေးဇူးပြု၍ ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
        "qrNotFound": "အစားအစာ မှာယူရန် QR Code အချက်အလက် မတွေ့ပါ။ <br>ကျေးဇူးပြု၍ ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
        "paymentSuccess": "ဝန်ဆောင်မှုကို အသုံးပြုသည့်အတွက် ကျေးဇူးတင်ပါသည်!",
        "invalidQrType": "ကျေးဇူးပြု၍ dynamic QR Code ရယူရန် ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
        "tableMoved": "ကျေးဇူးပြု၍ QR Code အသစ်ရယူရန် ဝန်ထမ်းကို ဆက်သွယ်ပါ။",
        "receiptVoided": "ဝန်ဆောင်မှုကို အသုံးပြုသည့်အတွက် ကျေးဇူးတင်ပါသည်။<br>အကူအညီ လိုအပ်ပါက ဝန်ထမ်းကို ဆက်သွယ်ပါ။"
    },
    waitForServe: 'ဧည့်ခံရန် စောင့်ပါ',
    DineInPaymentDetails: 'ငွေပေးချေမှု',
    silomPayProDesp: 'Silom Pay Easy ဖြင့် လုံခြုံသော ငွေပေးချေမှု',
    billDetail: 'ဘီလ် အသေးစိတ်',
    minute: 'မိနစ်',
    paymentTImeExpired: 'အချိန်ကုန်သွားပါပြီ',
    openApp: 'အက်ပ် ဖွင့်ပါ',
    callPayStaffSuccess: 'ဝန်ထမ်းကို ခေါ်ပြီးပါပြီ<br>ငွေပေးချေမှု ပြီးမြောက်ရန် ကျေးဇူးပြု၍ စောင့်ပါ',
    account: 'အကောင့်',
    refNumber: 'ကိုးကားနံပါတ်',
    QRCodeBBL: 'ခရက်ဒစ်ကတ် QR Code',
    trackOrderStatus: 'အော်ဒါ အခြေအနေ ခြေရာခံပါ',
    all: 'အားလုံး',
    noOrderThisStatus: 'ဤအခြေအနေတွင် အော်ဒါ မရှိပါ',
    orderCompleteThanks: 'ဝန်ဆောင်မှုကို အသုံးပြုသည့်အတွက် ကျေးဇူးတင်ပါသည်!',
    OnPreparingYourOrder: 'သင့်အော်ဒါ ပြင်ဆင်နေပါသည်...',
    goToTracking: 'ခြေရာခံ စာမျက်နှာသို့ သွားပါ',
    "dine-in": 'ဆိုင်တွင် စားသောက်',
    typeOfOrder: 'အော်ဒါ အမျိုးအစား',
    queue: 'တန်းစီ',
    cooking: 'ချက်ပြုတ်နေသည်',
    orderedAt: 'မှာယူချိန်',
    orderTimeStatus: 'မှာယူချိန်',
    acceptTimeStatus: 'လက်ခံချိန်',
    estTimeStatus: 'ခန့်မှန်းချိန်',
    newOrderDelivery: 'အော်ဒါ အသစ်',
    acceptOrderDelivery: 'အော်ဒါ လက်ခံ',
    readyToServeDelivery: 'ဧည့်ခံရန် အဆင်သင့်',
    orderCompleted: 'အော်ဒါ ပြီးဆုံး',
    orderCanceled: 'အော်ဒါ ပယ်ဖျက်ပြီး',
    readyToShip: 'ပို့ဆောင်ရန် အဆင်သင့်',
    scanForPayment: 'ငွေပေးချေရန် စကင်ဖတ်ပါ',
    orderType: 'အော်ဒါ အမျိုးအစား',
    welcomeBack: "ပြန်လည်ကြိုဆိုပါသည် 👋",
    welcomeBackDespt: "အစားအစာ ဆက်လက်မှာယူရန် ဝင်ရောက်ပါ",
    orLoginWith: "သို့မဟုတ် ဝင်ရောက်ပါ",
    dontHaveAccount: 'အကောင့် မရှိသေးပါသလား။',
    register: 'မှတ်ပုံတင်ပါ',
    fullName: "အမည်အပြည့်အစုံ",
    fullNameDespt: 'သင့်အမည် အပြည့်အစုံ',
    emailDespt: 'သင့်အီးမေးလ်',
    createPassword: 'စကားဝှက် ဖန်တီးပါ',
    alreadyHaveAccount: 'အကောင့် ရှိပြီးသား',
    verifyEmail: 'အီးမေးလ် အတည်ပြုပါ',
    enterOTPSentTo: 'ပို့ထားသော OTP ထည့်ပါ ',
    enterSixOTP: 'ဂဏန်း ၆ လုံး OTP ထည့်ပါ',
    verifyOTP: 'OTP အတည်ပြုပါ',
    weWillSentOTPEmail: 'သင့်အီးမေးလ်သို့ OTP ပို့ပါမည်',
    enterYourEmail: 'သင့်အီးမေးလ် ထည့်ပါ',
    confirmNewPassword: 'စကားဝှက်အသစ် အတည်ပြုပါ',
    sendOTP: 'OTP ပို့ပါ',
    addPhoneNumber: 'ဖုန်းနံပါတ် ထည့်ပါ',
    addPhoneForRegister: 'မှတ်ပုံတင်ရန် ဖုန်းနံပါတ် ထည့်ပါ',
    enterPhone: 'ဖုန်းနံပါတ် ထည့်ပါ',
    phoneUsed: 'ဖုန်းနံပါတ် အသုံးပြုပြီးပါပြီ',
    emailUsed: 'အီးမေးလ် အသုံးပြုပြီးပါပြီ',
    enterPassword: 'သင့်စကားဝှက် ထည့်ပါ',
    registerEmail: 'မှတ်ပုံတင်ထားသော အီးမေးလ်',
    otpInvalid6: "ကျေးဇူးပြု၍ မှန်ကန်သော ဂဏန်း ၆ လုံး OTP ထည့်ပါ။",
    emailVerified: "အီးမေးလ် အတည်ပြုပြီးပါပြီ!",
    emailOrPasswordInvalid: 'အီးမေးလ် သို့မဟုတ် စကားဝှက် မှားယွင်းပါသည်',
    pleaseEnterEmail: 'ကျေးဇူးပြု၍ အီးမေးလ် ထည့်ပါ',
    otpSentToEmail: "အီးမေးလ်သို့ OTP ပို့ပြီးပါပြီ",
    passwordNotMatch: "စကားဝှက် မကိုက်ညီပါ",
    resetPasswordCompleted: 'စကားဝှက် ပြန်သတ်မှတ်ပြီးပါပြီ!',
    failResetPassword: 'စကားဝှက် ပြန်သတ်မှတ်ရန် မအောင်မြင်ပါ',
    completePhoneFail: 'ဖုန်းနံပါတ် မှတ်ပုံတင် မအောင်မြင်ပါ',
    plaseEnterValidEmail: 'ကျေးဇူးပြု၍ မှန်ကန်သော အီးမေးလ် ထည့်ပါ',
    invalidPhoneNumber: 'ဖုန်းနံပါတ်သည် 06, 08 သို့မဟုတ် 09 ဖြင့် စပြီး ဂဏန်း ၁၀ လုံး ရှိရပါမည်',
    example: 'ဥပမာ',
    passwordSet: "ဂဏန်း ၆ လုံးထက် ပိုရမည်ဖြစ်ပြီး နံပါတ် ပါဝင်ရပါမည်",
    SelectTableToAdd: 'စားပွဲ',
    availableTable: 'ရနိုင်',
    unAvailableTable: 'မရနိုင်',
    SelectTableToAddDesp: 'ဆိုင်တွင်း စားသောက်ရန် စားပွဲ ရွေးပါ<br>မှတ်ချက်: စားပွဲ ပြောင်းလိုပါက ဝန်ထမ်းကို ဆက်သွယ်ပါ',
    updatedStaus: 'အခြေအနေ အပ်ဒိတ်ပြီးပါပြီ',
    otpExpired: 'OTP သက်တမ်းကုန်ပါပြီ',
    and: "နှင့်",
    emailOTP: "အီးမေးလ် OTP",
    emailOTPDesp: "အီးမေးလ်မှ ရရှိသော OTP ထည့်ပါ",
    phoneOTP: "ဖုန်း OTP",
    phoneOTPDesp: "SMS မှ ရရှိသော OTP ထည့်ပါ",
    checkSpamBox: '* အီးမေးလ် မရရှိပါက Spam သို့မဟုတ် Junk ဖိုဒါကို စစ်ဆေးပါ။ တစ်ခါတစ်ရံ မိနစ်အနည်းငယ် ကြာနိုင်ပါသည်။',
    DineInPaymentPending: 'ငွေပေးချေမှု စောင့်ဆိုင်းနေသည်',
    visitProceedPayment: 'ငွေပေးချေရန် သွားပါ',
    proceedPayment: "ငွေပေးချေမှု ဆက်လုပ်ပါ",
    proceedPaymentDesp: "ဤဘီလ်သည် ငွေပေးချေမှု ဆောင်ရွက်နေပါသည်။<br>ထပ်မံ မှာယူလိုပါက<br>ကျေးဇူးပြု၍ လက်ရှိ ငွေပေးချေမှုကို ပယ်ဖျက်ပါ",
    queueIndex: 'တန်းစီ',
    otpSentToPhone: 'SMS ဖြင့် OTP ပို့ပြီးပါပြီ။',
    failToSendOTP: 'OTP ပို့၍ မရပါ',
    somethingWentWrong: 'တစ်ခုခု မှားယွင်းသွားပါသည်',
    tableHasNoOrder: 'စားပွဲတွင် အော်ဒါ မရှိပါ',
    kbankProceedPaymentDesp: 'ဤဘီလ်သည် ငွေပေးချေမှု ဆောင်ရွက်နေပါသည်။<br>ထပ်မံ မှာယူလိုပါက သို့မဟုတ် ငွေပေးချေနည်းလမ်း ပြောင်းလိုပါက<br>ကျေးဇူးပြု၍ လက်ရှိ ငွေပေးချေမှုကို ပယ်ဖျက်ပါ'
,
  openHours: 'ဖွင့်',
}

export default messages
